import { GET_PRICE_REQUEST, GET_PRICE_SUCCESS, GET_PRICE_ERROR } from '../types';
export const getPriceRequest = input => ({
  type: GET_PRICE_REQUEST,
  payload: {
    input
  }
});
export const getPriceSuccess = (data, input) => ({
  type: GET_PRICE_SUCCESS,
  payload: {
    data,
    input
  }
});
export const getPriceError = (error, input) => ({
  type: GET_PRICE_ERROR,
  error,
  payload: {
    input
  }
});
export const getPrice = input => {
  return async (dispatch, _getState, _ref) => {
    let {
      chord
    } = _ref;
    dispatch(getPriceRequest(input));
    try {
      const data = await chord.oms.getVariantPrice(input);
      dispatch(getPriceSuccess(data, input));
      return data;
    } catch (error) {
      dispatch(getPriceError(error, input));
      throw error;
    }
  };
};